export const getDxAiPatientClinicMuiAccordionDetails = (palette: any) => ({
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        padding: "0px !important",
        borderTop: "none",
      },
    },
  },
});
